import useGiveawayAwards from './useGiveawayAwards';
import ConfirmValidateAwardModal from '../../../../GiveawayWinners/components/ConfirmValidateAwardModal';
import AccordionAward from '../../AccordionAward';
import Loading from '../../../../../../components/Loading';

export default function GiveawayAwards() {
    const {
        tableData,
        invalidating,
        isConfirmValidateAwardModalVisible,
        handleValidateFinished,
        handleCancelValidateAward,
        selectedAward,
        onClickViewAppUser,
        handleClickValidateAward,
        isLoading
    } = useGiveawayAwards();

    return (
        <>
            <Loading loading={isLoading} ></Loading>
            {tableData.map((data, index) => {
                return <AccordionAward
                    key={index}
                    award={data}
                    onChangeStatus={handleClickValidateAward}
                    onVerUsuario={onClickViewAppUser}
                />
            })}

            {
                isConfirmValidateAwardModalVisible && (
                    <ConfirmValidateAwardModal
                        open={true}
                        award={selectedAward}
                        latestAwardHistory={selectedAward?.award_history?.slice().sort((a, b) => b.id - a.id)[0]}
                        invalidating={invalidating}
                        onValidateFinished={handleValidateFinished}
                        onCancel={handleCancelValidateAward}
                    />
                )
            }
        </>
    )
}
